'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dSystem from "./presto.types$-Site-System.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteSystem$$anon$127(_$ordinal$33, \u03b4name$33, outer) {
  this.cxJ = 0;
  this.a9E = null;
  this.cxJ = _$ordinal$33;
  this.a9E = \u03b4name$33;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$SiteSystem$$anon$127 as $c_Lpresto_types$SiteSystem$$anon$127 };
$p = $c_Lpresto_types$SiteSystem$$anon$127.prototype = new $j_presto$002etypes$0024$002dSite$002dSystem.$h_Lpresto_types$SiteSystem();
$p.constructor = $c_Lpresto_types$SiteSystem$$anon$127;
/** @constructor */
function $h_Lpresto_types$SiteSystem$$anon$127() {
}
export { $h_Lpresto_types$SiteSystem$$anon$127 as $h_Lpresto_types$SiteSystem$$anon$127 };
$h_Lpresto_types$SiteSystem$$anon$127.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a9E;
});
$p.l = (function() {
  return this.a9E;
});
var $d_Lpresto_types$SiteSystem$$anon$127 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteSystem$$anon$127, "presto.types$SiteSystem$$anon$127", ({
  a2p: 1,
  a2n: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$SiteSystem$$anon$127 as $d_Lpresto_types$SiteSystem$$anon$127 };
//# sourceMappingURL=presto.types$-Site-System$$anon$127.js.map
